import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, DialogFooter, CheckboxVisibility } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../app/Hooks"
import { getPage } from "../../../app/Pages"
import { setPage } from "../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../common/Table/Table"
import { ApiMessage, getHeaders } from "../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';

import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb'
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { getMainTheme } from "../../../app/Themes"
import { SearchField } from "../../common/SearchField/SearchField"
import { formatDate, printComponent, normalizeKey } from "../../../app/Helpers"
import { TableState } from "../../common/Table/TableSate"
import { Message } from "../../common/Message/Message"
import { ShareBox } from "../../common/ShareBox/ShareBox"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { bool } from "yup"
import { GetOrganizationsRequest, UpdateOrganizationStateRequest } from "../../../repository/UserManagement/organization_pb"
import { addOrganization, dismissMessage, getOrganizations, reset, resetOrganizations, setIsFilteredSet, setNumberOfResults, setSearchText, setSelectedOrganization, setSort, updateOrganization, updateStatus } from "./OrganizationsPageSlice"
import { Popup } from "../../common/Popup/Popup"
import { FormType } from "../../forms/FormProps"
import { OrganizationsForm } from "../../forms/Organizations/OrganizationsForm"
import { useReactToPrint } from "react-to-print"
import { PageProps } from "../PageProps"

const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};


let req: GetOrganizationsRequest;

let org: number = -1;

let getOrganizationsPromise: any;


const key = "organizations"
export const OrganizationsPage: React.FunctionComponent<PageProps> = (props) => {


    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const state: {
        isChangeStateLoading: boolean,
        organizations: TableState, message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean, searchText: string | undefined,
        filters: any[]
    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.organizationsPage.isChangeStateLoading,
            organizations: state.organizationsPage.organizations, message: state.organizationsPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            searchText: state.organizationsPage.searchText,
            filters: state.organizationsPage.filters

        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const statusActionConfirmationcalloutTargetId = useId('activity-action-callout-target');
    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');

    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)
    const ref = useRef<HTMLDivElement>(null);
        const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});
    const getActionId = (action: number): string => {
        if (action == 1)
            return statusActionConfirmationcalloutTargetId;
        else {
            return ""
        }
    }
    const _selection = useConst(() => new Selection({
        onSelectionChanged: () => {
            if (_selection.count > 0) {
                dispatch(setSelectedOrganization(_selection.getSelection()));
            } else {
                dispatch(setSelectedOrganization([]));
            }
        },

    }));


    const clearFilter = () => {

    }

    const search = (searchText: string | undefined) => {
        let isFiltered: boolean = false;

        if (searchText) {
            const wrapper = new StringValue();
            wrapper.setValue(searchText.trim());
            req.setSearch(wrapper)
            isFiltered = true;
        } else {
            req.setSearch(undefined)
        }
        req.setNextto(0)
        dispatch(resetOrganizations())
        dispatch(setIsFilteredSet(isFiltered))
        getOrganizationsPromise?.abort()
        getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))
    }


    useEffect(() => {

        req = new GetOrganizationsRequest();
        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
            }
        }
        if (!props.isSelection) {
            const page = getPage(key)
            dispatch(setTitle(t(normalizeKey(page?.title))));
            dispatch(setPage(page));
        }
        req.setNextto(0)
        req.setNumofresults(state.organizations.numberOfResults)
        req.setOrder(state.organizations.isDescending)


        getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))
        return () => { //clean up
            getOrganizationsPromise?.abort();
            dispatch(reset());
        }
    }, [])


    const c: IColumn[] = [

        {
            key: 'name',
            name: t("organization"),
            minWidth: 20,
            maxWidth: 250,
            isRowHeader: true,
            isResizable: true,
    
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                return <Link onClick={(e) => {
                    if (e) {
                        e.preventDefault();
                        navigate("/organizations/" + item?.id + ((org == -1) ? "" : "?org=" + org));
                    }
                }
                } href={"/organizations/" + item?.id + ((org == -1) ? "" : "?org=" + org)} > {item?.name == "" ? item?.id : item?.name}</Link >;
            },
        },

        {
            key: 'domain',
            name: t("domain"),
            minWidth: 20,
            maxWidth: 100,
            isRowHeader: true,
            isResizable: true,
            
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                return <Text>{item?.domain}</Text>;
            },
        },

        {
            key: 'isActive',
            name: t("status"),
            minWidth: 50,
            maxWidth: 60,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {
                return <Text>{item?.isActive ? t("active") : t("inactive")}</Text>;
            },
        },

        {
            key: 'createdDate',
            name: t("createdDate"),
            minWidth: 20,
            maxWidth: 150,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {


                return <Text>{(item?.createdDate)}</Text>; //{item.createdDate}
            },
        },
        {
            key: 'enter',
            name: '',
            minWidth: 20,
            maxWidth: 60,
            isRowHeader: true,
            isResizable: true,
            data: 'string',
            isPadded: true,
            onRender: (item) => {

                return <PrimaryButton onClick={(e) => {
                    window.location.href = "/?org=" + item?.id;
                }}>{t("enterOrganization")}</PrimaryButton>; //{item.createdDate}
            },
        },



    ];

    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'edit',
            text: t("edit"),
            title: t('edit'),
            iconProps: { iconName: 'EditSolid12' },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(101)
                }
            }

        },
        {
            key: 'status',
            text: (state.organizations.selected.length > 0 && state.organizations.selected.at(0)?.isActive) ? t("deactivateOrganization") : t("activateOrganization"),
            title: (state.organizations.selected.length > 0 && state.organizations.selected.at(0)?.isActive) ? t("deactivateOrganization") : t("activateOrganization"),

            iconProps: { id: statusActionConfirmationcalloutTargetId, iconName: (state.organizations.selected.length > 0 && state.organizations.selected.at(0)?.isActive) ? "UserRemove" : "UserFollowed", styles: { root: { fontWeight: (state.organizations.selected.length > 0 && state.organizations.selected.at(0)?.isActive) ? undefined : "bold" } } },

            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 1 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 1 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 1 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(1)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },
        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.organizations.selected.at(0)?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },

        {
            key: 'share',
            text: t("share"),
            title: t("share"),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },
    ];

    const mainOptions: ICommandBarItemProps[] = [
        {
            key: 'newItem',
            text: t('add'),
            title: t("add"),
            iconProps: { iconName: 'Add' },
            onClick: () => {
                setCurrenctAction(100)
            }
        },
        {
            key: 'refresh',
            text: t('refresh'),
            title: t("refresh"),
            iconProps: { iconName: 'refresh' },
            disabled: state.organizations.isFetching,
            onClick: () => {
                dispatch(resetOrganizations())
                req.setNextto(0)

                getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))
            }
        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);;
                }
            }
        },
    ];
    const _farOptions: ICommandBarItemProps[] = [
        {
            key: 'sort',
            text: t('sort'),
            title: t("sort"),
            iconProps: { iconName: 'sort' },
            disabled: state.organizations.isFetching,
            subMenuProps: {
                items: [{
                    key: 'ascending',
                    text: t('ascendingDate'),
                    title: t("ascendingDate"),
                    canCheck: true,
                    checked: !state.organizations.isDescending,
                    onClick: () => {
                        dispatch(setSort(false))
                        dispatch(resetOrganizations())
                        req.setOrder(false)
                        req.setNextto(0)
                        getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))

                    }


                }, {
                    key: 'descending',
                    text: t('descendingDate'),
                    title: t("descendingDate"),
                    canCheck: true,
                    checked: state.organizations.isDescending,
                    onClick: () => {
                        dispatch(setSort(true))
                        dispatch(resetOrganizations())
                        req.setOrder(true)
                        req.setNextto(0)
                        getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))

                    }

                }]
            }
        }


    ];
    const _farBottomOptions: ICommandBarItemProps[] = [
        {
            key: 'results',
            text: t('results') + ': ' + state.organizations.numberOfResults,
            title: t('results') + ': ' + state.organizations.numberOfResults,
            iconProps: { iconName: 'ShowResults' },
            subMenuProps: {
                items: [{
                    key: '10',
                    text: '10',
                    title: '10',
                    canCheck: true,
                    checked: (state.organizations.numberOfResults == 10 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(10))
                        req.setNumofresults(10)
                    }


                }, {
                    key: '50',
                    text: '50',
                    title: '50',
                    canCheck: true,
                    checked: (state.organizations.numberOfResults == 50 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(50))
                        req.setNumofresults(50)
                    }

                },
                {
                    key: '100',
                    text: '100',
                    title: '100',
                    canCheck: true,
                    checked: (state.organizations.numberOfResults == 100 ? true : false),
                    onClick: () => {
                        dispatch(setNumberOfResults(100))
                        req.setNumofresults(100)
                    }

                }]
            }
        }
    ];




    return (
        <Stack >
            <Popup isOpen={(currentAction == 100)} title={t("addOrganization")} onDismiss={() => { setCurrenctAction(0) }} >

                <OrganizationsForm childrenGap={10} maxWidth={280} type={FormType.ADD} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(addOrganization(e))

                }} onCancel={() => { setCurrenctAction(0) }} />
            </Popup>
            <Popup isOpen={(currentAction == 101)} title={t("editOrganization")} onDismiss={() => { setCurrenctAction(0) }} >

                <OrganizationsForm childrenGap={10} maxWidth={280} type={FormType.EDIT} fetchData={true} renderObject={state.organizations.selected.at(0)} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateOrganization(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }
            <CommandBar
                items={state.organizations.selected.length == 0 ? mainOptions : _selectionItems}
                farItems={_farOptions}

            //id={actionConfirmationcalloutTargetId}

            />
            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareOrganization")} value={`https://${window.location.host}/management/organizations/${state.organizations.selected.at(0).id}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}


            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12, } }}>
                            {(currentAction == 1 ? (state.organizations.selected.at(0)?.isActive) ? t("deactivateOrganization") : t("activateOrganization") : "")}
                        </Text>
                        <Text block variant="small">
                            {(currentAction == 1 ? (state.organizations.selected.at(0)?.isActive) ? t("deactivateOrganizationDesc") : t("activateOrganizationDesc") : "")}

                        </Text>
                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.organizations.selected.length > 0) {
                                        if (currentAction == 1) {
                                            let req = new UpdateOrganizationStateRequest();
                                            req.setId(state.organizations.selected.at(0)?.id)
                                            req.setIsactive(!state.organizations.selected.at(0)?.isActive)
                                            dispatch(updateStatus({ body: req, headers: getHeaders() }))

                                        }
                                    }
                                }} text={(currentAction == 1 ? (state.organizations.selected.at(0)?.isActive) ? t("deactivate") : t("activate") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}



            <Stack.Item align="center"  >
                <Stack horizontal  >
                    <SearchField
                        inputProps={{
                            maxLength: 250,
                            placeholder: t("search"),
                        }}

                        onInputChange={(e) => {
                            dispatch(setSearchText(e));
                            return e;
                        }}
                        endButtons={[
                            {
                                title: t("search"), checked: true, iconProps: { iconName: "search" }, onClick: () => {
                                    search(state.searchText);
                                }
                            }]}
                        onChange={(e) => {
                            const res = state.filters.filter(({ key: key1 }) => !e?.some(({ key: key2 }) => key1 === key2));
                            res?.forEach(e => {

                            });

                        }}

                        onResolveSuggestions={() => { return [] }}
                        selectedItems={state.filters.map(e => { return { name: e.name, key: e.key } as ITag }) || []}
                        onSearch={(e) => {
                            search(state.searchText);
                        }}
                        onClear={(e) => {
                            dispatch(setSearchText(undefined))
                            if (state.organizations.isFilteredSet) {
                                search(undefined);
                            }
                        }}
                        showIcon
                    />
                </Stack>
            </Stack.Item>


            <Table
                setKey="organizations"
                items={state.organizations.items}
                width={props.isSelection ? '80vw' : undefined}
                height={props.isSelection ? "60vh" : state.message == undefined ? "calc(100vh - 176px)" : "calc(100vh - 224px)"}
                columns={c}
                checkboxVisibility={props.isSelection ? CheckboxVisibility.always : CheckboxVisibility.onHover}
                compRef={ref}
                onScroll={(e) => {
                    const bottom = e?.currentTarget?.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                    if (bottom && !state.organizations.isFetching && state.organizations.hasMore) {
                        req.setNextto(state.organizations.items.at(state.organizations.items.length - 11)?.id)
                        getOrganizationsPromise?.abort();
                        getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))

                    }
                }}
                selection={_selection}
                selectionMode={SelectionMode.single}
                disableSelectionZone={state.isChangeStateLoading}
                enableShimmer={state.organizations.items.length == 0 && state.organizations.isFetching}
                layoutMode={props.isSelection ? DetailsListLayoutMode.fixedColumns : DetailsListLayoutMode.justified}
                
                isColumnSortingEnabled={state.organizations.selected.length == 0}
                numberOfResultsOptions={[10, 50, 100]}
                selectedNumberOfResults={state.organizations.numberOfResults}
                onNumberOfResultsChange={(e) => {
                    dispatch(setNumberOfResults(e))
                    req.setNumofresults(e)
                }}

                onRowDidMount={(item?: any, index?: number) => {
                    //alert(index)
                    if (index == state.organizations.items.length - 11) { // last element renderd
                        const { current } = ref;
                        if (current) {
                            if (state.organizations.items.length > 0 && !state.organizations.isFetching && state.organizations.hasMore) {
                                if (current.scrollHeight == current.clientHeight) { // scroll not shown? get more data 
                                    req.setNextto(state.organizations.items.at(state.organizations.items.length - 11)?.id)
                                    getOrganizationsPromise?.abort();
                                    getOrganizationsPromise = dispatch(getOrganizations({ body: req, headers: getHeaders() }))
                                }


                            }
                        }
                    }
                }}
            />

            {props.isSelection ? <DialogFooter>
                <PrimaryButton disabled={state.organizations.isFetching || state.organizations.selected.length == 0} text={state.organizations.isFetching ? undefined : t("select")} onClick={() => {
                    if (props.onItemSelected && state.organizations.selected.length > 0) {
                        props.onItemSelected(state.organizations.selected.at(0))
                    }
                }} >

                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.organizations.isFetching ? "block" : "none") } }} />

                </PrimaryButton>
                <DefaultButton disabled={state.organizations.isFetching} text={t("discard")} onClick={() => {
                    if (props.onCancel) {
                        props.onCancel()
                    }
                }} />
            </DialogFooter> : undefined}
        </Stack>



    );
}



